module.exports = __webpack_public_path__ + "static/media/MetaMask_Fox.c879a582.svg";